export default "__VITE_ASSET__DzUPj5Pc__"